import { Badge } from '@shopify/polaris'
import { Tone } from '@shopify/polaris/build/ts/src/components/Badge'
import React from 'react'

import { SubscriptionContractSubscriptionStatus } from './api'
import { capitalize } from './helpers'
import { SubscriptionContract } from './subscription-models'

const statusBadgeTone = (status: SubscriptionContractSubscriptionStatus): Tone | undefined => {
  if (status === SubscriptionContractSubscriptionStatus.Active) {
    return 'success'
  }

  if (status === SubscriptionContractSubscriptionStatus.Failed) {
    return 'critical'
  }

  if (status === SubscriptionContractSubscriptionStatus.Paused) {
    return 'attention'
  }

  return undefined
}

interface Props {
  sc: SubscriptionContract
}

export const SubscriptionStatusBadge = ({ sc }: Props) => (
  <Badge tone={statusBadgeTone(sc.gql_status)}>
    {sc.gql_status === 'PAUSED' && !sc.activated_at ? 'Inactive' : capitalize(sc.gql_status)}
  </Badge>
)
